export * from '../src/composites/wui-banner-img/index.js';
//# sourceMappingURL=wui-banner-img.js.map